"use client";

import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import type { MouseEvent, SVGProps } from "react";
import { Clock, Facebook, Instagram, Mail, MapPin, Phone, Youtube } from "lucide-react";
const services = ["Service Motociclete", "Vulcanizare", "Detailing", "ATV & Scootere"];
const legalDetails = ["PURE MOTO PERFORMANCE S.R.L.", "CUI: 52511016", "Nr. Reg. Com.: J2025070050005", "Sediu social: Str. Ion Luca Caragiale nr. 4, bl. 19, sc. B, ap. 8, Brașov, jud. Brașov", "Punct de lucru: Strada Timișul Sec nr. 4, Brașov 500163, România", "CAEN: 9532 - Repararea și întreținerea motocicletelor"];
function TiktokIcon(props: SVGProps<SVGSVGElement>) {
  return <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64c.3 0 .6.05.88.14V9.4a6.33 6.33 0 0 0-.88-.06 6.34 6.34 0 0 0-5.36 9.72 6.34 6.34 0 0 0 11.68-3.39V8.74a8.16 8.16 0 0 0 4.77 1.52V6.8c-.33 0-.66-.04-.98-.11Z" />
    </svg>;
}
const socials = [{
  name: "Instagram",
  url: "https://www.instagram.com/pure.moto.performance/",
  icon: Instagram
}, {
  name: "Facebook",
  url: "https://www.facebook.com/profile.php?id=100083288015101",
  icon: Facebook
}, {
  name: "TikTok",
  url: "https://www.tiktok.com/@pure.moto.performance",
  icon: TiktokIcon
}, {
  name: "YouTube",
  url: "https://www.youtube.com/@PureMotoPerformance",
  icon: Youtube
}];
const googleMapsUrl = "https://www.google.com/maps/place/Pure+Moto+Performance/@45.6572106,25.6434986,828m/data=!3m1!1e3!4m6!3m5!1s0x40b35d242725e959:0xd8259985ad99edf!8m2!3d45.6572069!4d25.6460735!16s%2Fg%2F11pz8t8shm?entry=ttu&g_ep=EgoyMDI2MDUwMi4wIKXMDSoASAFQAw%3D%3D";
export default function PieDePaginaCorporativo() {
  const currentYear = new Date().getFullYear();
  const handleServicesClick = (event: MouseEvent<HTMLAnchorElement>) => {
    const element = document.querySelector("#expertiza-noastră-moto");
    if (!element) return;
    event.preventDefault();
    const headerOffset = 80;
    const top = element.getBoundingClientRect().top + window.scrollY - headerOffset;
    window.scrollTo({
      top,
      behavior: "smooth"
    });
  };
  return <section data-section-id="223219" id="footer" className="dark bg-background text-foreground py-16 px-4 md:px-8 lg:px-12 border-t border-border">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {}
          <div className="flex flex-col gap-6">
            <Link to="/" className="inline-block w-fit">
              <img src="https://grateful-javelin.10web.cloud/wp-content/uploads/2026/05/Finished-Logo-White-Outline.png" alt="Pure Moto Performance Logo" className="object-contain !h-[90px] !w-[100px]" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed font-default">
              Service moto profesional în Brașov cu peste 7 ani de experiență.
              Pasiune pentru viteză, precizie în execuție și respect pentru
              fiecare motocicletă care ne trece pragul.
            </p>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-default text-lg font-bold tracking-tight uppercase text-foreground">
              Servicii
            </h3>
            <ul className="flex flex-col gap-3">
              {services.map((service, index) => <li key={index} data-index={index}>
                  <Link to="/#expertiza-noastră-moto" onClick={handleServicesClick} className="text-muted-foreground hover:text-primary transition-colors text-sm font-default flex items-center gap-2 group">
                    <span className="w-1.5 h-1.5 rounded-full bg-primary/50 group-hover:bg-primary transition-colors" />
                    {service}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-default text-lg font-bold tracking-tight uppercase text-foreground">
              Contact
            </h3>
            <ul className="flex flex-col gap-4">
              <li>
                <Link to="tel:+40745236441" className="text-muted-foreground hover:text-primary transition-colors text-sm font-default flex items-center gap-3">
                  <Phone className="size-4 text-primary" />
                  0745 236 441
                </Link>
              </li>
              <li>
                <Link to="mailto:puremotoperformance@gmail.com" className="text-muted-foreground hover:text-primary transition-colors text-sm font-default flex items-center gap-3">
                  <Mail className="size-4 text-primary" />
                  puremotoperformance@gmail.com
                </Link>
              </li>
            </ul>
            <div className="mt-2">
              <h4 className="text-sm font-bold mb-3 text-foreground/80 uppercase tracking-wider">
                Social Media
              </h4>
              <div className="flex gap-4">
                {socials.map((social, index) => {
                const Icon = social.icon;
                return <Link key={index} data-index={index} to={social.url} newTab className="text-muted-foreground hover:text-primary transition-colors p-2 -ml-2 rounded-md hover:bg-primary/10" aria-label={`Deschide ${social.name}`}>
                      <Icon className="size-5" />
                    </Link>;
              })}
              </div>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-default text-lg font-bold tracking-tight uppercase text-foreground">
              Locație
            </h3>
            <Link to={googleMapsUrl} newTab className="flex gap-3 text-muted-foreground text-sm font-default transition-colors hover:text-primary">
              <MapPin className="size-4 text-primary shrink-0 mt-0.5" />
              <p className="leading-relaxed">
                Strada Timișul Sec, nr. 4,
                <br />
                Brașov 500163, România
              </p>
            </Link>
            <div className="flex gap-3 text-muted-foreground text-sm font-default">
              <Clock className="size-4 text-primary shrink-0 mt-0.5" />
              <p className="leading-relaxed">
                Luni-vineri 10-18
                <br />
                Sâmbătă 10-13
              </p>
            </div>
            <Link to={googleMapsUrl} newTab className="mt-2 block overflow-hidden rounded-md border border-border/50 bg-muted/20 relative group" aria-label="Deschide locația Pure Moto Performance în Google Maps">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645494/img/pure_moto_brasov_map_footer.png" alt="Locație Service Moto Brașov" className="w-full h-32 object-cover opacity-60 group-hover:opacity-100 transition-opacity duration-500 grayscale group-hover:grayscale-0" />
              <div className="absolute inset-0 ring-1 ring-inset ring-primary/20 rounded-md pointer-events-none" />
            </Link>
          </div>
        </div>

        <Separator className="my-8 bg-border/20" />

        {}
        <div className="flex flex-col gap-6 text-xs text-muted-foreground font-default">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <h4 className="mb-3 text-sm font-bold uppercase tracking-wider text-foreground/80">
                Informații legale
              </h4>
              <ul className="space-y-1.5 leading-relaxed">
                {legalDetails.map(detail => <li key={detail}>{detail}</li>)}
              </ul>
            </div>
          </div>

          <Separator className="bg-border/20" />

          <p>
            &copy; {currentYear} Pure Moto Performance. Toate drepturile
            rezervate.
          </p>
        </div>
      </div>
    </section>;
}